export default {
  SET_REGION_LIST(state, params) {
    state.remRegionList = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/rem/region/regionMutations.js